/** Full Google account sign-out in this browser (Gmail, YouTube, etc.). */
export const GOOGLE_BROWSER_LOGOUT_URL = 'https://accounts.google.com/Logout';

export function isGoogleBrowserLogoutUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return (
      parsed.hostname === 'accounts.google.com' &&
      parsed.pathname.replace(/\/+$/, '') === '/Logout'
    );
  } catch {
    return false;
  }
}
